import script from "./kclb.vue?vue&type=script&setup=true&lang=js"
export * from "./kclb.vue?vue&type=script&setup=true&lang=js"

import "./kclb.vue?vue&type=style&index=0&id=3583e473&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3583e473"]])

export default __exports__